<template>
  <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
    <div class="rounded-t bg-white mb-0 px-6 py-6">
      <div class="text-center flex justify-between">
        <h6 class="text-blueGray-700 text-xl font-bold">{{ pageType }} Pricing</h6>
        <button
          class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
          type="button" @click="onSubmit(pricing)">
          Submit
        </button>
      </div>
    </div>
    <div class="flex-auto px-4 lg:px-10 py-10 pt-0">

      <div class="w-full lg:w-12/12 px-4 mt-3" v-if="alertType != ''">
        <div class="text-white px-4 py-2 border-0 rounded relative mb-4"
          v-bind:class="{ 'bg-emerald-500': alertType == 'Success', 'bg-red-500': alertType == 'Failed' }">
          <span class="text-m inline-block mr-5 align-middle">
            <i class="fas fa-bell"></i>
          </span>
          <span class="inline-block align-middle mr-8">
            <b class="capitalize">{{ alertType }}!</b> {{ alertMessage }}
          </span>
          <button
            class="absolute bg-transparent text-2xl font-semibold leading-none right-0 top-0 mt-2 mr-6 outline-none focus:outline-none">
            <span>×</span>
          </button>
        </div>
      </div>
      <div class="flex flex-wrap mt-3">
        <div class="w-full lg:w-4/12 px-4">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
              Client Name
            </label>
            <select v-model="pricing.client_name"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150">
              <option v-for="(item, key) in clients" :value="item.client_name" :key="key">
                {{ item.client_name }}
              </option>
            </select>
          </div>
        </div>
        <div class="w-full lg:w-4/12 px-4">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
              Intention
            </label>
            <input v-model="pricing.intention" type="text"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
          </div>
        </div>
      </div>
      <div class="flex flex-wrap mt-3">
        <div class="flex w-full lg:w-12/12" v-for="(item, key) in pricing.pricing_models" :key="key">
          <div class="w-full lg:w-3/12 px-4">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                Base Price
              </label>
              <input v-model="item.base_price" type="number" min="0"
                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
            </div>
          </div>
          <div class="w-full lg:w-3/12 px-4">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                Min Unit
              </label>
              <input v-model="item.min_unit" type="number" min="0"
                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
            </div>
          </div>
          <div class="w-full lg:w-3/12 px-4">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                Max Unit
              </label>
              <input v-model="item.max_unit" type="number" min="0"
                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
            </div>
          </div>
          <div class="w-full lg:w-3/12 px-4">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                Progressive
              </label>
              <input v-model="item.progressive" type="number" min="0"
                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
            </div>
          </div>
          <div class="w-full lg:w-1/12 px-4">
            <div class="relative w-full mb-3 mt-7">
              <a class="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                v-on:click="onClickRemove(key)" href="#" v-if="key > 0">
                <i class="fa fa-times"></i>
              </a>
            </div>
          </div>

        </div>
        <div class="w-full lg:w-6/12 px-4">
          <a class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
            v-on:click="onClickAdd" href="#">
            Add Plan
          </a>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import ClientDataService from "@/services/ClientDataService";
import constants from "@/constants";
import ErrorHandler from "@/ErrorHandler";
export default {
  data() {
    return {
      pricing: {
        pricing_models: [{}]
      },
      clients: [],
      methods: []
    };
  },
  props: {
    pageType: String,
    onSubmit: { type: Function },
    alertType: String,
    alertMessage: String,
    showModal: Boolean,
    toggleModal: { type: Function },
    clientProps: { type: Object }
  },
  watch: {
    clientProps: function (newVal, oldVal) { // watch it
      console.log('Prop changed: ', newVal, ' | was: ', oldVal)
      this.pricing = newVal
    }
  },
  mounted() {
    this.methods = constants.methods
    this.getClients()
  },
  methods: {
    onClickRemove(key) {
      this.pricing.pricing_models.splice(key, 1)
    },
    onClickAdd() {
      this.pricing.pricing_models.push({})
    },
    getClients() {
      ClientDataService.getAll(100, 1)
        .then(response => {
          this.clients = response.data["data"]["clients"];
        })
        .catch(e => {
          console.log(e);
          ErrorHandler(e)
        });
    },
  }
}
</script>